import React, { useState } from 'react';
import { Card, Modal } from 'semantic-ui-react';
import { Mode } from '../../../../constants';
import { Inventory } from '../../../../routes';
import { history } from '../../../../store';
import ReadOnlyMapContainer from '../../../BuildingSummary/ReadOnlyMapContainer';
import styles from './Components/styles/InventoryOverviewPopup.module.scss';
import ButtonWrapper from '../../../common/ButtonWrapper';
import Title from './Components/Title';
import HazardIcon from './Components/HazardIcon';
import SimplifiedInventoryLabel, { LabelType } from './Components/SimplifiedInventoryLabel';
import { Loading } from 'react-lib/dist/components-es';
import { useTranslation } from 'react-i18next';
import DownloadableFileWrapper from './Components/DownloadableFileWrapper';
import DownloadInventoryStickersModal from '@components/Inventory/DownloadInventoryStickersModal';
import { gridTemplatesOptions } from 'objects/StickerGridTemplate';
import PersonPopupWrapper from './Components/PersonPopupWrapper';

const InventorySimplifiedView = ({
  displayInventroyDetails,
  isOpen,
  handlePopupClose,
  trigger,
  handleDefaultFilteredListOverride,
  entityId,
  isLoading,
  showPersonalData,
}) => {
  const [mapImage, setMapImage] = useState(null);
  const { t } = useTranslation();

  const { inventory } = displayInventroyDetails || {};
  const { chemicalProduct, orgUnit, location, contacts } = inventory || {};

  const { tradeName, hazardStatements } = chemicalProduct || '';
  const { hazards, casNumber, unNumber, sdsFiles } = chemicalProduct || {};

  const { name } = orgUnit || '';
  const personList = [];
  const hazardStatement = [];
  const fileDataList = [];
  const downloadFileName = `inventory-${tradeName}-qr-sticker.pdf`.replace(/\s+/g, '');

  if (contacts !== undefined) {
    contacts.map(contact => {
      const { person } = contact || {};
      return personList.push(person);
    });
  }
  if (sdsFiles !== undefined) {
    sdsFiles.map(file => {
      const { fileData } = file || {};
      return fileDataList.push(fileData);
    });
  }

  if (hazardStatements !== undefined) {
    hazardStatements.map(newHazardStatement => {
      const statement = newHazardStatement.statement;
      const description = newHazardStatement.description;
      return hazardStatement.push({ statement, description });
    });
  }

  const redirectHandler = mode => {
    handleDefaultFilteredListOverride();
    history.push(Inventory.baseName + `/${mode}` + (entityId ? `/${entityId}` : `/:id`));
  };
  return (
    <div className={styles.overviewPopup}>
      <Modal
        closeIcon
        open={isOpen}
        onClose={handlePopupClose}
        trigger={trigger}
        className={styles.modal}
      >
        {!inventory ? (
          <div className="buildingMapContainer">
            <Loading isLoading={true} />
          </div>
        ) : (
          <>
            <Title inventory={inventory} />
            <Modal.Content className={styles.modalContent}>
              <div className={styles.contentContainer}>
                <SimplifiedInventoryLabel labelType={LabelType.organicUnit} value={name} />
                <PersonPopupWrapper personList={personList} showPersonalData={showPersonalData} />
                <Card className={styles.chemicalInformationCard}>
                  <HazardIcon hazards={hazards} />
                  <SimplifiedInventoryLabel
                    labelType={LabelType.unNumber}
                    value={unNumber?.unNumber}
                  />
                  <SimplifiedInventoryLabel
                    labelType={LabelType.casNumber}
                    value={casNumber?.casNumber}
                  />
                  <SimplifiedInventoryLabel
                    labelType={LabelType.hazardStatement}
                    value={hazardStatement}
                  />
                  <DownloadableFileWrapper fileData={fileDataList} />
                </Card>
                <div className={styles.divFooter}>
                  <DownloadInventoryStickersModal
                    selectedInventoriesDict={{ [entityId]: true }}
                    gridTemplateCreatorOptions={gridTemplatesOptions}
                    downloadFileName={downloadFileName}
                    drawBox={false}
                    classNamePopup={`${styles.downloadButton} ${styles.inlineElements}`}
                  />
                  <ButtonWrapper
                    type="button"
                    onClick={() => redirectHandler(Mode.VIEW)}
                    label={t('details.button')}
                    color={'blue'}
                    size={'medium'}
                    icon="zoom-in"
                    className={`${styles.ButtonWrapper} ${styles.inlineElements}`}
                  />
                </div>
              </div>
              <div className={styles.GISmap}>
                <Loading isLoading={isLoading} />
                {location && (
                  <ReadOnlyMapContainer
                    location={location}
                    setMapImage={setMapImage}
                    isBuilding={false}
                    scale={100}
                  />
                )}
              </div>
            </Modal.Content>
          </>
        )}
      </Modal>
    </div>
  );
};
export default InventorySimplifiedView;
